export default __webpack_public_path__ + "static/media/NAR-CAKE.22d68382.svg";